export const ADD_ERROR = 'add_error'
export const addError = (payload) => ({
  type: ADD_ERROR,
  payload,
})
